import { Component } from '@verndale/core';
import Swiper from 'swiper';
import debounce from 'lodash/debounce';
import { BREAKPOINT } from '../../constants';

class OneworldPriorityResult extends Component {
  constructor(el) {
    super(el);
    this.init();
  }
  setupDefaults() {
    this.dom = {
      $window: $(window),
      $slider: this.$el.find('.services__slider'),
      $list: this.$el.find('.services__list'),
      $items: this.$el.find('.services__item'),
      $tabs: this.$el.find('.oneworld-priority-result__tabs-list'),
      $tab: this.$el.find('.oneworld-priority-result__tab'),
      $result_content: this.$el.find('.oneworld-priority-result__content'),
      $result_content_emerald: this.$el.find(
        '.oneworld-priority-result__content.emerald'
      ),
      $result_content_sapphire: this.$el.find(
        '.oneworld-priority-result__content.sapphire'
      ),
      $result_content_ruby: this.$el.find('.oneworld-priority-result__content.ruby'),
      $priority_result_services: this.$el.find(
        '.oneworld-priority-result__services'
      ),
      $priority_result_services_ruby: this.$el.find(
        '.oneworld-priority-result__services.ruby'
      ),
      $priority_result_services_sapphire: this.$el.find(
        '.oneworld-priority-result__services.sapphire'
      ),
      $priority_result_services_emerald: this.$el.find(
        '.oneworld-priority-result__services.emerald'
      ),
      $indicator: this.$el.find('.oneworld-priority-result__tab-indicator '),
      $tabs_header: this.$el.find('.oneworld-priority-result__tabs-header')
    };
    this.width = document.body.clientWidth;
    this.initSwiper();
  }

  addListeners() {
    this.dom.$tab.on('click touchstart', ::this.handleTabClick);
    this.dom.$window.on('resize', debounce(::this.handleResize, 300));
  }

  init() {
    if (this.dom.$indicator.length > 0) {
      const tabIndicatorWidth = 100 / this.dom.$tab.length;
      this.dom.$indicator.css('width', `${tabIndicatorWidth}%`);
      this.updateIndicator();
    }
  }

  handleTabClick(data) {
    this.dom.$tabs
      .removeClass('emerald')
      .removeClass('sapphire')
      .removeClass('ruby');
    this.dom.$indicator
      .removeClass('emerald')
      .removeClass('sapphire')
      .removeClass('ruby');
    this.dom.$tabs_header
      .removeClass('emerald')
      .removeClass('sapphire')
      .removeClass('ruby');
    this.dom.$tab.removeClass('active');
    this.dom.$result_content.removeClass('active');
    this.dom.$priority_result_services.removeClass('active');

    $(data.target).addClass('active');
    if ($(data.target).hasClass('emerald')) {
      this.dom.$tabs.addClass('emerald');
      this.dom.$indicator.addClass('emerald');
      this.dom.$tabs_header.addClass('emerald');
      this.dom.$result_content_emerald.addClass('active');
      this.dom.$priority_result_services_emerald.addClass('active');
    } else if ($(data.target).hasClass('sapphire')) {
      this.dom.$tabs.addClass('sapphire');
      this.dom.$indicator.addClass('sapphire');
      this.dom.$tabs_header.addClass('sapphire');
      this.dom.$result_content_sapphire.addClass('active');
      this.dom.$priority_result_services_sapphire.addClass('active');
    } else if ($(data.target).hasClass('ruby')) {
      this.dom.$tabs.addClass('ruby');
      this.dom.$indicator.addClass('ruby');
      this.dom.$tabs_header.addClass('ruby');
      this.dom.$result_content_ruby.addClass('active');
      this.dom.$priority_result_services_ruby.addClass('active');
    }
    this.updateIndicator();

    if (this.swiper) {
      this.updateSwipers();
    }
  }

  updateIndicator() {
    if (this.dom.$indicator.length > 0) {
      const $activeTab = this.dom.$tab.filter('.active');
      const indicatorNewPosition = $activeTab.position().left;
      this.dom.$indicator.css('left', `${indicatorNewPosition}px`);
    }
  }

  handleResize() {
    this.updateIndicator();
    if (this.width !== document.body.clientWidth) {
      this.width = document.body.clientWidth;
      this.initSwiper();
    }
  }

  initSwiper() {
    if (document.body.clientWidth >= BREAKPOINT.desktop) {
      if (this.swiper) {
        this.destroySwipers();
        this.removeStructure();
        this.swiper = null;
      }
      return;
    }
    if (this.swiper) {
      this.updateSwipers();
      return;
    }
    this.createStructure();

    this.swiper = new Swiper('.services__slider', {
      slidesPerView: 'auto',
      observeParents: true
    });
  }

  updateSwipers() {
    if (this.swiper.length) {
      this.swiper.forEach(swiper => swiper.update());
    } else {
      this.swiper.update();
    }
  }

  destroySwipers() {
    if (this.swiper.length) {
      this.swiper.forEach(swiper => swiper.destroy());
    } else {
      this.swiper.destroy();
    }
  }

  createStructure() {
    this.dom.$slider.addClass('swiper-container');
    this.dom.$list.addClass('swiper-wrapper');
    this.dom.$items.addClass('swiper-slide');
  }

  removeStructure() {
    this.dom.$slider.removeClass('swiper-container');
    this.dom.$list.removeClass('swiper-wrapper');
    this.dom.$items.removeClass('swiper-slide');
  }
}

export default OneworldPriorityResult;
